var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylAboutCarousel"}},[(_vm.isMobileScreen)?_c('ylAboutCarouselMobile',{attrs:{"list":_vm.list}}):_c('ylAboutCarouselPC',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }